module.exports = __webpack_public_path__ + "static/media/8OLA13.19749f44.jpg";